export const CANVAS_DAMAGE_REQUEST = "CANVAS_DAMAGE_REQUEST";
export const CANVAS_DAMAGE_SUCCESS = "CANVAS_DAMAGE_SUCCESS";
export const CANVAS_DAMAGE_FAILED = "CANVAS_DAMAGE_FAILED";